jQuery(document).ready(function () {
  const videoPlayer = document.querySelector(".video-embed");

  if (videoPlayer) {
    jQuery(".video-embed-thumbnail-wrapper svg").on("click", function () {
      jQuery(this).closest(".video-embed__container").addClass("play");
      jQuery(this).closest(".video-embed__container").find("iframe")[0].src +=
        "?autoplay=1";
    });
  }
});
